/**
 * Central event bus — émet les events Smootify iso doc.
 * Liste exhaustive : https://docs.smootify.io/docs/custom-code/js/events
 *
 * Events supportés (certains émis au moment où la feature est active) :
 *   - smootify:loaded                      (bundle initialisé)
 *   - smootify:cart_updated                (toute modif du panier)
 *   - smootify:added_to_cart               (détail: {lines, cart, goToCheckout})
 *   - smootify:removed_from_cart           (détail: lineIds)
 *   - smootify:product_loaded              (détail: {id, product})
 *   - smootify:productImagesModuleLoaded   (galerie prête)
 *   - smootify:user_auth_change            (login/logout, v2 accounts)
 *   - smootify:variant_changed             (sélecteur options — sur <smootify-product>)
 *   - smootify:wishlist_updated            (ajout/retrait wishlist)
 *   - smootify:locale_changed              (switch market/langue)
 *   - smootify:error                       (erreurs runtime)
 *   - addon:state_change                   (bundle add-on, v2)
 */

export const SMOOTIFY_EVENTS = {
  LOADED: "smootify:loaded",
  CART_UPDATED: "smootify:cart_updated",
  ADDED_TO_CART: "smootify:added_to_cart",
  REMOVED_FROM_CART: "smootify:removed_from_cart",
  PRODUCT_LOADED: "smootify:product_loaded",
  PRODUCT_IMAGES_MODULE_LOADED: "smootify:productImagesModuleLoaded",
  USER_AUTH_CHANGE: "smootify:user_auth_change",
  VARIANT_CHANGED: "smootify:variant_changed",
  WISHLIST_UPDATED: "smootify:wishlist_updated",
  LOCALE_CHANGED: "smootify:locale_changed",
  ERROR: "smootify:error",
  ADDON_STATE_CHANGE: "addon:state_change",
} as const;

/** Emit un custom event sur `document` (ou une target explicite). */
export function emit<T = unknown>(
  name: string,
  detail?: T,
  target: EventTarget = document,
): void {
  target.dispatchEvent(new CustomEvent(name, { detail, bubbles: true }));
}

/** Support du sucre `<script type="smootify-load">...</script>` : exécute
 *  le contenu après `smootify:loaded`. */
export function setupSmootifyLoadScripts(): void {
  const run = () => {
    const scripts = document.querySelectorAll<HTMLScriptElement>(
      'script[type="smootify-load"]',
    );
    scripts.forEach((s) => {
      try {
        // eslint-disable-next-line @typescript-eslint/no-implied-eval
        const fn = new Function(s.textContent || "");
        fn();
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error("smootify-load script error:", e);
      }
    });
  };
  if (document.readyState === "loading") {
    document.addEventListener("smootify:loaded", run, { once: true });
  } else {
    // Event déjà dispatché — on lance dans la microtask suivante.
    Promise.resolve().then(run);
  }
}
